/**
 * DGUIRenderer — renders a single DGUI block using the component registry.
 */

import { createElement } from 'react';
import type { DGUIComponentSchema } from '@flowrithm/shared/src/features/ai-assist/types/dgui';
import { getDGUIComponent } from './dgui/registry';

interface DGUIRendererProps {
  schema: DGUIComponentSchema;
}

export function DGUIRenderer({ schema }: DGUIRendererProps) {
  const { component, props } = schema;
  const Component = getDGUIComponent(component);
  if (!Component) {
    return null;
  }
  return createElement(Component, props ?? {});
}
